import * as React from 'react';
import styled from 'styled-components';

// Components
import { TextField } from '../../../../../../../../../components/TextField';
import PlainRenderInputElement from './PlainRenderInputElement';

// Context
import { RuleEditorContext } from '../../context';

// Enums
import { dtoState } from '../../../../../../../../../common/enums/dtoState';

// Hooks
import { useCriteriaStorePredicate } from '../../../../../../../state/criteria/hooks/useCriteriaStorePredicate';
import { useCriteriaStoreUpdatePredicate } from '../../../../../../../state/criteria/hooks/useCriteriaStoreUpdatePredicate';
import { useDebouncedStringCallback } from '../../../../../../hooks/useDebouncedStringCallback';

// Types
import { ruleEditorViewPartCommonProps } from '../../types';

const TextInputContainer = styled.div`
    max-width: 14rem;
`;

export const TextInput = ({
    id,
    predicateType,
    placeholder = 'Enter text value...',
    plainrender = true,
    type,
    ...props
}) => {
    const { setEdited } = React.useContext(RuleEditorContext);
    const part = useCriteriaStorePredicate(id);
    const updatePredicateElement = useCriteriaStoreUpdatePredicate();
    const [textValue, setTextValue] = useDebouncedStringCallback({
        startVal: part?.text,
        debounceCallback: (newVal) => {
            setEdited(true);
            updatePredicateElement({
                ...part,
                dtoState: dtoState.Updated,
                text: newVal
            });
        }
    });

    if (plainrender) {
        return (
            <PlainRenderInputElement
                value={textValue}
                placeholderPartial={`${type} value`}
                overridable={part?.overridable}
            />
        );
    }

    return (
        <TextInputContainer>
            <TextField
                withBorder
                size={'xs'}
                id={`part_text_input_${id}`}
                name={`part_text_input_${id}`}
                value={textValue}
                onInput={(e) => {
                    setTextValue(e.target.value);
                }}
                placeholder={placeholder}
            />
        </TextInputContainer>
    );
};

export default TextInput;

TextInput.propTypes = {
    ...ruleEditorViewPartCommonProps
};
